
import { Watch, Mixins, Component, Ref, InjectReactive, Emit } from "vue-property-decorator";

import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { ElForm } from "element-ui/types/form";

import { dataStoreMerchant } from "@/api/data";

import { getMerchantStoreList } from "@/api/store";

const orderEnum = {
    descending: 1,  // 降序
    ascending: 2,   // 升序
};

@Component({
    components: {
        ETable,
    }
})
export default class StoreDataMerchant extends Mixins(Resize, TablePagination) {
    [x: string]: any;
    @Ref("addFormRef") AddFormRef!: ElForm;
    @InjectReactive() activeName!: string;

    storeTypeList = [
        { name: "品牌商", val: 30006 },
        { name: "品牌商合作店", val: 30005 }
    ]

    queryForm = {
        storeType: undefined,
        merchantName: undefined,
        storeName: undefined,
        sort: undefined,
        sortRule: undefined,
        storeShowName: "",
        pageNum: 1,
        pageSize: 10,
    }

    loading = false;
    tableData = [];
    itemTotal = 0;

    userLoading = false;
    allMerchantList = [];

    columns = [
        { label: "门店类型", prop: "storeType" },
        { label: "门店名称", prop: "storeName" },
        { label: "门店外显名称", prop: "storeShowName" },
        { label: "中医大脑总数", prop: "screenSum", sortable: "custom" },
        { label: "中医大脑在线", prop: "screenOnlineSum", sortable: "custom" },
        { label: "中医大脑最近30天在线", prop: "screenMonthSum", sortable: "custom" },
        { label: "最近检测时间", prop: "detectionTime", sortable: "custom" },
        { label: "舌诊到期时间", prop: "tongueExpiredTime", sortable: "custom" },
        { label: "脉诊到期时间", prop: "pulseTakeExpiredTime", sortable: "custom" },
    ]

    mounted() {
        this.windowResize(280);
    }

    getMerchantList(str) {
        if (typeof str == "object") {
            str = "";
        }
        this.userLoading = true;
        getMerchantStoreList({
            name: str
        })
            .then((res) => {
                this.userLoading = false;
                const allMerchantList = res.data || [];
                this.allMerchantList = allMerchantList.map((item) => {
                    item.name = item.name;
                    item.id = item.id;
                    return item;
                });
            })
            .catch((err) => {
                this.userLoading = false;
            });
    }

    //重置分页参数
    resetPages() {
        this.currentPage = 1;
        this.queryForm.sort = undefined;
        this.queryForm.sortRule = undefined;
        // 清除表格排序状态
        this.$nextTick(() => {
            const table = this.$refs.table as any;
            if (table && table.$refs && table.$refs.ElTableRef) {
                table.$refs.ElTableRef.clearSort();
            }
        });
    }

    goStore(row) {
        this.$router.push({
            path: "/storeList",
            query: {
                storeName: encodeURIComponent(row.storeName),
            }
        })
    }

    // 搜索
    handleSearch() {
        this.resetPages();
        this.getData();
    }

    handleSortChange(e) {
        console.log(e);
        const { prop, order } = e;
        this.queryForm.sort = prop;
        this.queryForm.sortRule = orderEnum[order];
        this.getData();
    }

    @Watch("activeName", { immediate: true })
    getData() {
        if (this.activeName !== "third") return;
        const params = {
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
        }
        this.loading = true;
        dataStoreMerchant(params).then((res) => {
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
            this.tableData.forEach((el) => {
                el.storeTypeDesc = this.storeTypeList.find(el2 => el2.val == el.storeType)?.name;
            })
        }).finally(() => {
            this.loading = false;
        })
    }

    @Watch("storeTypeList", { deep: true })
    formatTableData() {
        if (!this.storeTypeList?.length) return;
        this.tableData.forEach((el) => {
            el.storeTypeDesc = this.storeTypeList.find(el2 => el2.val == el.storeType)?.name;
        })
    }
}
